export default __webpack_public_path__ + "static/media/basketIcon.c4cf6004.svg";